"use client";

import React, { useEffect, useState } from 'react';
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="221616" className="hidden md:flex items-center gap-8">
        <div className="h-4 w-20 bg-muted/50 animate-pulse rounded"></div>
        <div className="h-4 w-20 bg-muted/50 animate-pulse rounded"></div>
        <div className="h-4 w-20 bg-muted/50 animate-pulse rounded"></div>
      </div>;
  }
  return <nav className="hidden md:flex items-center gap-8">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || '#'} data-index={i} className="text-sm font-default tracking-tight uppercase text-foreground/90 hover:text-primary relative after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">
          {item.label}
        </Link>)}
    </nav>;
}
function MobileNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  return <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-transparent hover:text-primary">
          <Menu className="size-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] sm:w-[400px] bg-background border-l border-border">
        <SheetTitle className="sr-only">Mobile Navigation</SheetTitle>
        <div className="flex flex-col h-full pt-16 pb-6 px-2">
          {loading ? <div className="space-y-6">
              <div className="h-8 w-3/4 bg-muted/50 animate-pulse rounded"></div>
              <div className="h-8 w-1/2 bg-muted/50 animate-pulse rounded"></div>
              <div className="h-8 w-2/3 bg-muted/50 animate-pulse rounded"></div>
            </div> : <nav className="flex flex-col gap-8">
              {menuItems.map((item, i) => <Link key={item.id} to={item.href || '#'} data-index={i} onClick={() => setIsOpen(false)} className="text-2xl font-default font-bold tracking-tight text-foreground/90 hover:text-primary transition-colors">
                  {item.label}
                </Link>)}
              <div className="mt-8">
                <Button className="w-full rounded-full font-default font-bold tracking-tight uppercase text-sm py-6 shadow-lg shadow-primary/20 bg-primary hover:bg-primary/90 transition-all">
                  Emergency Call
                </Button>
              </div>
            </nav>}
        </div>
      </SheetContent>
    </Sheet>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <section id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 bg-background text-foreground ${isScrolled ? 'bg-background/80 backdrop-blur-xl border-b border-border shadow-md' : 'bg-background border-b border-transparent'}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 sm:h-24">
          
          {}
          <div className="flex-1 flex justify-start">
            <MenuProvider menu_id="16">
              <DesktopNav />
            </MenuProvider>
          </div>

          {}
          <div className="flex-shrink-0 flex justify-center">
            <Link to="/" className="flex items-center justify-center group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/drive_mobile_tyres_logo.png" alt="Drive Mobile Tyres Leeds" className="h-10 transition-transform duration-300 group-hover:scale-105" />
            </Link>
          </div>

          {}
          <div className="flex-1 flex justify-end items-center gap-4">
            <div className="hidden md:block">
              <Button variant="default" className="rounded-full font-mono font-bold tracking-tight uppercase text-sm px-8 py-6 shadow-lg shadow-primary/20 bg-primary hover:bg-primary/90 transition-all relative overflow-hidden group">
                <span className="relative z-10 flex items-center gap-2">
                  <span className="size-2 bg-white rounded-full animate-pulse"></span>
                  Emergency Call
                </span>
              </Button>
            </div>
            
            <MenuProvider menu_id="16">
              <MobileNav />
            </MenuProvider>
          </div>

        </div>
      </div>
    </section>;
}